import { render, staticRenderFns } from "./TextareaWithAudio.vue?vue&type=template&id=b5654f62&scoped=true"
import script from "./TextareaWithAudio.vue?vue&type=script&lang=js"
export * from "./TextareaWithAudio.vue?vue&type=script&lang=js"
import style0 from "./TextareaWithAudio.vue?vue&type=style&index=0&id=b5654f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5654f62",
  null
  
)

export default component.exports